import React, { useState } from 'react';

import { UiButton } from '../../../../ui/ui-button';
import { UiDialog } from '../../../../ui/ui-dialog';

export const DisableAccountDialog = ({
  account,
  cancelTransition,
  handleTransitionConfirmed,
}: AccountStatusTransitionDialogProps) => {
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const handleCancel = () => {
    setIsSubmitting(true);
    handleTransitionConfirmed();
  };
  return (
    <div>
      <UiDialog
        onClose={cancelTransition}
        title={`Are you sure you want to cancel ${account.accountName}?`}
      >
        <UiDialog.Content>
          If this customer has multiple organizations / brands, they will all be canceled. This will
          also deactivate all users and jobs and cancel the customer&apos;s subscription in Stripe.
        </UiDialog.Content>
        <UiDialog.Actions>
          <UiButton onClick={cancelTransition} variant="secondary">
            Never Mind
          </UiButton>
          <UiButton variant="primary" onClick={handleCancel} disabled={isSubmitting}>
            Cancel Account
          </UiButton>
        </UiDialog.Actions>
      </UiDialog>
    </div>
  );
};
